import React from "react";
import { Dropdown, DropdownItem } from "nectar-ui";
import {
  DASHBOARD_ACTIVITY_TYPES_DICTIONARY,
  DashboardActivityTypesKeys,
} from "@utils/constants/dashboard/dashboardModuleConstants";
import DashboardFilterButton from "../../DashboardFilterButton";

type DashboardChartCaseTypeSelectorProps = {
  allowedFilters: string[];
  currentFilter: DashboardActivityTypesKeys;
  filterSetter: (newFilter: string) => void;
};

const DashboardChartCaseTypeSelector: React.FC<DashboardChartCaseTypeSelectorProps> = ({
  allowedFilters,
  currentFilter,
  filterSetter,
}) => {
  const handleItemClick = (selectedFilter: string) => (_event: React.MouseEvent) => {
    filterSetter(selectedFilter);
  };

  const caseTypeOptions = allowedFilters.map((filter: DashboardActivityTypesKeys) => {
    return (
      <DropdownItem key={filter} onClick={handleItemClick(filter)}>
        {DASHBOARD_ACTIVITY_TYPES_DICTIONARY[filter].label}
      </DropdownItem>
    );
  });
  return (
    <Dropdown
      position="left"
      options={caseTypeOptions}
      action={
        <DashboardFilterButton>
          {DASHBOARD_ACTIVITY_TYPES_DICTIONARY[currentFilter].label}
        </DashboardFilterButton>
      }
    />
  );
};

export default DashboardChartCaseTypeSelector;
